module.exports = __webpack_public_path__ + "static/media/10.500c12f0.png";